module.exports = __webpack_public_path__ + "static/media/company-introduction-3.ea77ecac.jpg";